class CartItemModel {
  constructor({
    id = null,
    name = null,
    type = null,
    validity = null,
    value = null,
    price = null,
    quantity = null,
    recipients = [],
  } = {}) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.validity = validity;
    this.value = value;
    this.price = price;
    this.quantity = quantity;
    this.recipients = recipients;
  }

  json() {
    return {
      price: this.price,
      id: this.id,
      name: this.name,
      type: this.type,
      validity: this.validity,
      value: this.value,
      quantity: this.quantity,
      recipients: this.recipients,
    };
  }
}

module.exports = CartItemModel;
